function PageNotFound() {
    return (
        <div className="h-full">
            <div className="text-center inline-block absolute w-full"
                 style={{top: "50%", transform: "translateY(-50%)"}}>
                <div className='font-bold'>BookFinder</div>
                <div>PageNotFound</div>
                <br/>
            </div>
        </div>
    );
}

export default PageNotFound;
